export default __webpack_public_path__ + "static/media/add-announcement-enabled.9933bf4b.svg";